export default __webpack_public_path__ + "static/media/identify.677a7904.PNG";